import { AuthHeader } from './../_models/headers';


import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { EnrolmentRequestInformation } from '../_models/EnrolmentRequestInformation';
import { PaymentInformation } from '../_models/payments/PaymentInformation';
import { StudentRegData } from '../_models/registration/StudentRegData';
import { ResultData } from '../_models/ResultData';
import { Student } from '../_models/student';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root'
})
export class StudentService {
  aHeader = undefined


  public studentSubject=new BehaviorSubject<Student>(new Student());
  public minStudentData=new BehaviorSubject<any>({});
  public bearerJsonHeaders =new HttpHeaders()
  constructor(
    private http: HttpClient,
    private headerService:HeaderService,
    private dataUtilService:DataUtilService,private tss:AuthService) {
      this.aHeader = new AuthHeader(tss)

    }
  enrolStudent(formData:string){
    return this.http.post(`${environment.apiUrl}/enrolment/angularsave`, formData, this.aHeader.bearerFormHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
  }
  generatePaymentOrderId() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }
  enrolProvision(formData:PaymentInformation){
    return this.http.post(`${environment.apiUrl}/enrolment/provision`, formData, this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
  }
  enrolSave(formData:EnrolmentRequestInformation):Observable <ResultData> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`});
    return this.http.post<ResultData>(`${environment.apiUrl}/student/enrol`, formData,{headers})
  }
  enrolSaveInvoice(formData:EnrolmentRequestInformation):Observable <ResultData> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${this.tss.getToken()}`});
    return this.http.post<ResultData>(`${environment.apiUrl}/student/saveInvoice`, formData,{headers})
  }

  verifyPayment(server_student_id:number,formData:string){
    return this.http.post<Student>(`${environment.apiUrl}/student/verifyPayment/${server_student_id}`,formData,this.aHeader.bearerFormHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }
      }))
  }

  getWorksheet(quizEnvelopId:number):Observable<ResultData>{
    return this.http.get<ResultData>(`${environment.apiUrl}/quizEnvelop/downloadStudentWorksheet/${quizEnvelopId}`,{headers:this.headerService.openPdfHeaders()})

  }
  downloadFreeWorksheet(uuid:string):Observable<ResultData>{
    return this.http.get<ResultData>(`${environment.apiUrl}/quizEnvelop/downloadFreeWorksheet/${uuid}`,{headers:this.headerService.openPdfHeaders()})

  }
  createFreeQuiz(server_subject_id:number,formData:string):Observable<ResultData>{
     return this.http.post<ResultData>(`${environment.apiUrl}/quizEnvelop/createFreeWorkbook/${server_subject_id}`, formData, {headers:this.headerService.bearerFormHeaders()})

  }
  registerStudent(formData:StudentRegData){
    return this.http.post(`${environment.apiUrl}/student/angularsave`, formData, this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
  }
  registerEnrolStudent(formData:EnrolmentRequestInformation):Observable <ResultData> {
    return this.http.post<ResultData>(`${environment.apiUrl}/student/enrol`, formData, {headers:this.headerService.bearerJsonHeaders()})

  }


  registerGroupStudent(formData:string, id:number){
    return this.http.post(`${environment.apiUrl}/subscriptionGrouping/registerGroupStudent/${id}`, formData, this.aHeader.bearerFormHeaders)
      .pipe(map(data => {
        if(this.dataUtilService.isGoodResponse(data)){
          return this.dataUtilService.myData(data)
        }

      }));
  }
  getWebPendingQuizCount(serverStudentUserId: number) {
    let pp = new URLSearchParams()
    pp.set("id",serverStudentUserId.toString())

    return this.http.get<Student>(`${environment.apiUrl}/student/pendingquizcount/${serverStudentUserId}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
    let student:any= {}
     if(this.dataUtilService.isGoodResponse(data)){
       return this.dataUtilService.myData(data)
     }
     return student
   }))
}

  getWebPendingQuiz(serverStudentUserId: number,quiz_mode_name:string) {
     let pp = new URLSearchParams()
     pp.set("id",serverStudentUserId.toString())
     pp.set("quiz_mode_name",quiz_mode_name)

    return this.http.get(`${environment.apiUrl}/student/webpendingquiz/${serverStudentUserId}/${quiz_mode_name}`,this.aHeader.bearerFormHeaders).pipe(map(data => {
      let student:any= {}
      if(this.dataUtilService.isGoodResponse(data)){
        student= this.dataUtilService.myData(data)
      }

      return student
    }))
}

getDoneQuizByStudentUserId(serverStudentUserId: number,quiz_mode_name:string) {

  return this.http.get<Student>(`${environment.apiUrl}/student/webdonequiz/${serverStudentUserId}/${quiz_mode_name}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
    let student:any= {}
    if(this.dataUtilService.isGoodResponse(data)){
      student= this.dataUtilService.myData(data)
    }

    return student
  }))
}
getGiftingInformation(serverStudentUserId: number) {

  return this.http.get<any>(`${environment.apiUrl}/student/giftinfo/${serverStudentUserId}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
    let student:any= {}
    if(this.dataUtilService.isGoodResponse(data)){
      student= this.dataUtilService.myData(data)
    }

    return student
  }))
}

getLearner(serverStudentUserId: number) {

  return this.http.get<any>(`${environment.apiUrl}/student/learner/${serverStudentUserId}`, this.aHeader.bearerJsonHeaders).pipe(map(data => {
    let student:any= {}
    if(this.dataUtilService.isGoodResponse(data)){
      student= this.dataUtilService.myData(data)
    }

    return student
  }))
}
getEnrollments(serverStudentUserId: number) {

  return this.http.get<any>(`${environment.apiUrl}/student/getenrolments/${serverStudentUserId}`, this.aHeader.bearerJsonHeaders).pipe(map(data => {
    let student:any= {}
    if(this.dataUtilService.isGoodResponse(data)){
      student= this.dataUtilService.myData(data)
    }

    return student
  }))
}
  getByUserId(userId: number) {

      return this.http.get<Student>(`${environment.apiUrl}/student/user/${userId}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
        let student= new Student()
        if(this.dataUtilService.isGoodResponse(data)){
          student= this.dataUtilService.myData(data)
          this.studentSubject.next(student)
        }

        return student
      }))
  }

  getStudentById(server_student_id: number,) {
      return this.http.get<Student>(`${environment.apiUrl}/student/apistudentshow/${server_student_id}`,this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        let student= new Student()
        if(this.dataUtilService.isGoodResponse(data)){
          student= this.dataUtilService.myData(data)
          this.studentSubject.next(student)
        }
        return student
      }))
  }
  getBillingChoicesByLevel(levelId:number){
    return this.http.get<any>(`${environment.apiUrl}/subject/getbillingchoicesbylevel/${levelId}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
      if(this.dataUtilService.isGoodResponse(data)){
        return this.dataUtilService.myData(data)
      }else{
        return {}
      }

    }))
  }


  // getCountryInfoByLevel(levelId: number) {
  //   return this.http.get<any>(`${environment.apiUrl}/level/country/${levelId}`,this.aHeader.bearerJsonHeaders).pipe(map(
  //     xx=>{
  //       if(this.dataUtilService.isGoodResponse(xx)){
  //         return this.dataUtilService.myData(xx)
  //       }else{
  //         return {}
  //       }
  //     }))
  //     }

  // getCountryInfo(userId: number) {
  //   return this.http.get<any>(`${environment.apiUrl}/subscription/apicountryinfo/${userId}`,this.aHeader.bearerJsonHeaders).pipe(map(
  //     xx=>{
  //       if(this.dataUtilService.isGoodResponse(xx)){
  //         return this.dataUtilService.myData(xx)
  //       }else{
  //         return {}
  //       }
  //     }))
  //     }

  // getCountries() {
  //   return this.http.get<any>(`${environment.apiUrl}/country/angularlist`,this.aHeader.openJsonHeaders).pipe(map(data => {
  //     let myData=[]
  //     if(this.dataUtilService.isGoodResponse(data)){
  //       myData= this.dataUtilService.myData(data)
  //     }

  //     return myData
  //   }))
  // }

  getScoreSummary(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/scoresummary2/${userId}`,this.aHeader.bearerJsonHeaders)
  }
  getQuizPending(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/quizpending2/${userId}`,this.aHeader.bearerJsonHeaders)
  }
  getQuizDone(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/quizdone2/${userId}`,this.aHeader.bearerJsonHeaders)
  }
  getQuizAll(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/quizall2/${userId}`,this.aHeader.bearerJsonHeaders)
  }
  getProgressReport(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/performance2/${userId}`,this.aHeader.bearerJsonHeaders)
  }
  getQuizTopics(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/quiztopics2/${userId}`,this.aHeader.bearerJsonHeaders)
  }

  getPerformanceReport(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/subscription/peformance2/${userId}`,this.aHeader.bearerJsonHeaders)
  }

  getStudentAwards(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/award/getawardsinfo/${userId}`,this.aHeader.bearerJsonHeaders).pipe(
      map(
        data=>{
          let myData=[]
          if(this.dataUtilService.isGoodResponse(data)){
            myData=this.dataUtilService.myData(data)
          }
          return myData
        }
      )
    )
  }

  getIndex() {

    return this.http.get<any>(`${environment.apiUrl}/student/apiindex`,this.aHeader.bearerJsonHeaders)
    .pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodObjectResponse(data)){
        myData= this.dataUtilService.myObjectData(data)
      }
      return myData
    }))
  }

  extractUserId(){
    let userId=0
    this.studentSubject.subscribe(
      x=>{
        userId=x.server_user_id
      }

    )
    return userId
  }
}
